// src/components/Auth/AuthError.tsx
import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { Component, ReactNode } from 'react';
import { ROUTES } from '../../auth/authConfig';

// 既存のエラー表示用Props
interface AuthErrorProps {
  error: Error;
}

// ErrorBoundary用のProps
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

// 既存のエラー表示コンポーネント
export const AuthError = ({ error }: AuthErrorProps) => {
  const getErrorMessage = (error: Error) => {
    switch (error.message) {
      case 'login_required':
        return 'ログインが必要です';
      case 'invalid_grant':
        return '認証情報が無効です';
      case 'interaction_required':
        return '再度ログインが必要です';
      default:
        return '認証エラーが発生しました';
    }
  };

  return (
    <Alert severity="error">
      <AlertTitle>エラー</AlertTitle>
      {getErrorMessage(error)}
    </Alert>
  );
};

// エラーバウンダリーコンポーネントを追加
export class AuthErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    console.error('Auth error caught:', error);
    // エラー監視サービスへの通知などを追加可能
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          p={2}
        >
          <AuthError error={this.state.error} />
          <Button
            variant="contained"
            onClick={() => window.location.href = ROUTES.login}
          >
            ログインページに戻る
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}